import axios from 'axios';
import { baseUrl } from '@/config';

const PREFIX_URL = '/event/rpt/';

export default {
  /**
   * [장애 예측 분석] 자원 설정 - 선택한 관리대상에 설정된 '이벤트 예측 자원' 목록을 조회한다.
   * @author Song
   */
  getPredictTargetRscList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-predict-target-rsc-list.do`, params);
  },
  /**
   * [장애 예측 분석] 자원 설정 - 선택한 관리대상에 설정된 '이벤트 예측 자원' 을 수정한다.
   * @author Song
   */
  setPredictAnalysisRscList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}set-predict-analysis-rsc-list.do`, params);
  },
  /**
   * [장애 예측 분석] 자원 설정 - 선택한 관리대상에 설정된 '이벤트 예측 자원' 목록을 조회한다.
   * @author Song
   */
  getPredictRptTargetRscList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-predict-rpt-target-rsc-list.do`, params);
  },
  /**
   * [장애 예측 분석] 장비 검색 필터링 컴포넌트 조회
   * @author Song
   */
  getEventRptTargetObjInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-event-rpt-target-obj-indo.do`, params);
  },
  /**
   * [장애 예측 분석] 장비 검색 필터링 컴포넌트 조회 (objDefine)
   * @author Song
   */
  getEventRptTargetObjDefine() {
    return axios.get(`${baseUrl}${PREFIX_URL}get-event-rpt-target-obj-define.do`);
  },
  /**
   * [장애 예측 분석] 자원 설정 - 자원 목록 - '이벤트 예측 자원' 자원 삭제
   * @author Song
   */
  deleteEventRptRscList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}delete-event-rpt-rsc-list.do`, params);
  },
  /**
   * [장애 예측 분석] 자원 설정 - 자원 목록 - '이벤트 예측 자원' 자원 삭제
   * @author Song
   */
  setEventRptSchedule(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}set-event-rpt-schedule.do`, params);
  },
  /**
   * [장애 예측 분석] 분석 결과 목록 조회
   * @author Song
   */
  getEventRptResultList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-event-rpt-result-list.do`, params);
  },
  /**
   * [장애 예측 분석] 분석 결과 '더보기' 차트 조회
   * @author Song
   */
  getTargetRptAnalysisChartData(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}get-target-rpt-analysis-chart-data.do`, params);
  },
  /**
   * [장애 예측 분석] 장애 예측 분석 스케줄이 돌고 있을 경우를 판단하기 위한 데이터 조회
   * @author Song
   */
  getEventRptScheduleStatus() {
    return axios.get(`${baseUrl}${PREFIX_URL}get-event-rpt-schedule-status.do`);
  },
  /**
   * [장애 예측 분석] 장애 예측 분석 스케줄이 돌고 있을 경우를 판단하기 위한 데이터 조회
   * @author Song
   */
  excelExportEventRptResultList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}excel-export-event-rpt-result-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/event/event-rpt.js